import { gql } from '@lcs/shared/api';

export const getDepartmentDetail = gql`
   query GetDepartmentDetail($id: UInt!) {
      department(id: $id) {
         departmentId
         accountId
         account {
            accountId
            name
         }
         name
         isActive
         departmentExtensionsConnection {
            items {
               extension {
                  extensionId
                  number
                  name
               }
            }
         }
         createDate
         createUser {
            userId
            name
         }
         updateDate
         updateUser {
            userId
            name
         }
      }
   }
`;
